import React, { Component, Fragment } from "react";
import { languageService } from "../../../Language/language.service";
import ThisTable from "../../Common/ThisTable";
import UISectionHeader from "../../Common/UISectionHeader";
import CustomForm from "../../../libraries/form";
import _ from "lodash";
import "./style.css";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import { arrayToSelectOptions } from "../../../utils/arrayToSelectOptions";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import HosTemplateEntryValidators, { getDateFromHosEntryTemplateDate } from "../Helper/HosTemplateEntryValidators";
import { hosEntryFormSchema } from "./schemas/hosEntryFormSchema";
import { StyledButtonActionsTable } from "../../Common/Buttons";
import { hosTemplateReportingPeriodTableSchema } from "./schemas/hosTemplateReportingPeriodTableSchema";
import { MultiDayHosGraphicalView } from "../Helper/HosGraphicalView";
import { HosGraphicalView } from "../Helper/HosGraphicalView/index_v2";
import HosValidators from "../Helper/HosValidators";

const MIN_DATE = "Current Day";

class AddHosEntries extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openAddEditHosEntryForm: false,
      addEditHosEntryData: {},
      addEditHosEntryFormSchema: null,
      addEditHosEntryFormState: null,
      hosReportingPeriodDate: null,
      selectedHosEntryIndex: -1,
      showloader: false,
    };
    this.compileHosEntryFormSchema = this.compileHosEntryFormSchema.bind(this);

    this.closeDialog = this.closeDialog.bind(this);
    this.openCreateHosEntryForm = this.openCreateHosEntryForm.bind(this);
    this.openEditOrDeleteHosEntryForm = this.openEditOrDeleteHosEntryForm.bind(this);
    this.addUpdateOrDeleteHosEntry = this.addUpdateOrDeleteHosEntry.bind(this);

    this.setShowLoader = this.setShowLoader.bind(this);
  }

  setShowLoader(status) {
    this.setState({ showloader: status });
  }

  // load Select Options for various form fields
  compileHosEntryFormSchema(firstRecord = false) {
    const { getHosLocationsSelectOptions, getServiceTypeBasedOnDutyType, hosDutyTypes, hosServiceTypes } = this.context;
    const notTemplateDuty = ["Normal Service", "Limbo", "Other"];
    let changeData = {
      dutyType: {
        selectOptions: arrayToSelectOptions(hosDutyTypes.filter((type) => notTemplateDuty.find((v) => v === type))),
      },
      startLocCode: {
        selectOptions: getHosLocationsSelectOptions(),
      },
      endLocCode: {
        selectOptions: getHosLocationsSelectOptions(),
      },
      serviceType: {
        selectOptions: arrayToSelectOptions(hosServiceTypes),
      },
    };
    if (firstRecord) {
      changeData.startDate = { disabled: true };
    }

    let formSchema = updateShortSchema(_.cloneDeep(hosEntryFormSchema), changeData);
    return formSchema;
  }

  closeDialog() {
    this.setState({ openAddEditHosEntryForm: false, addEditHosEntryData: {}, addEditHosEntryFormState: null, selectedHosEntryIndex: -1 });
  }

  /**
   * opens Hos Entry form in create state
   */
  openCreateHosEntryForm() {
    const { hq } = this.props;
    const { currentHosRecords } = this.props;
    // by default, we expect the user to enter the start date and time from the very start of the 24-hour day and end date to also be the same as the start date

    let initialData = {
      startDate: MIN_DATE,
      endDate: MIN_DATE,
      startLocCode: hq ? hq : null,
      endLocCode: hq ? hq : null,
    };
    if (currentHosRecords.length > 0) {
      const lastRecord = currentHosRecords[currentHosRecords.length - 1];
      // check if the last entry in hos has all required date and time values present
      if (!HosTemplateEntryValidators.validateMinCriteriaForHosRecord(lastRecord, true)) {
        return;
      }

      initialData = {
        dutyType: lastRecord.dutyType,
        startDate: lastRecord.endDate,
        endDate: lastRecord.endDate,
        startTime: lastRecord.endTime,
        endTime: lastRecord.endTime,
        startLocCode: lastRecord.endLocCode,
        endLocCode: lastRecord.endLocCode,
      };
    }
    this.setState({
      openAddEditHosEntryForm: true,
      addEditHosEntryFormSchema: this.compileHosEntryFormSchema(currentHosRecords.length === 0),
      addEditHosEntryData: initialData,
      addEditHosEntryFormState: "create",
    });
  }

  /**
   * opens Hos Entry form in edit, partialEdit or delete states
   * @param {number} index index of the selected Hos entry from the currentHosRecords
   * @param {"edit" | "partialEdit" | "delete"} formState the state in which we need to open the form
   */
  openEditOrDeleteHosEntryForm(index, formState) {
    const { currentHosRecords } = this.props;

    if (index < currentHosRecords.length) {
      let selectedRow = { ...currentHosRecords[index] };

      this.setState({
        selectedHosEntryIndex: index,
        addEditHosEntryFormSchema: this.compileHosEntryFormSchema(index === 0),
        openAddEditHosEntryForm: true,
        addEditHosEntryData: selectedRow,
        addEditHosEntryFormState: formState,
      });
    }
  }

  /**
   * adds or updates currentHosRecords based on the submission
   * @param {object} submission submission is an object with form fields property which contains all the submitted values by the form
   * @param {"add" | "update" | "delete"} action the action defines whether we want to "add" a new hos entry, "update" an existing hos entry or "delete" an existing hos entry
   */
  addUpdateOrDeleteHosEntry(submission, action) {
    const { getActivityTypeOpt2BasedOnCode, getHosLocationOpt2BasedOnCode } = this.context;
    const { selectedHosEntryIndex } = this.state;
    const { currentHosRecords } = this.props;

    if ((action === "update" || action === "delete") && selectedHosEntryIndex === -1 && selectedHosEntryIndex >= currentHosRecords.length) {
      console.log("Invalid pointers");
      console.log(this.state);
      return;
    }
    let updatedCurrentHosRecords = [...currentHosRecords];
    if (action === "delete") {
      updatedCurrentHosRecords.splice(selectedHosEntryIndex, 1);
    } else {
      let fields = {
        ...submission.fields,
      };

      let lastRecord = null;
      if (action === "update" && selectedHosEntryIndex > 0) {
        // load last Record for comparison
        lastRecord = currentHosRecords[selectedHosEntryIndex - 1];
      } else if (action === "add" && currentHosRecords.length > 0) {
        // load last Record for comparison
        lastRecord = currentHosRecords[currentHosRecords.length - 1];
      }

      fields = {
        ...fields,
        activityType: getActivityTypeOpt2BasedOnCode(submission.fields.activityTypeCode),
        startLoc: getHosLocationOpt2BasedOnCode(submission.fields.startLocCode),
        endLoc: getHosLocationOpt2BasedOnCode(submission.fields.endLocCode),
      };

      if (
        /*check if required values are present*/ (HosTemplateEntryValidators.validateMinCriteriaForHosRecord(fields, false) &&
          /*check if the entered values are non-conflicting*/ !HosTemplateEntryValidators.validateHosRecordForConflicts(
            fields,
            lastRecord,
            true,
          )) ||
        /* check for location conflicts*/ !HosTemplateEntryValidators.validateHosRecordForLocationConflict(fields, lastRecord, true) ||
        /*check if the entered values are for more than 24 hours*/ !HosTemplateEntryValidators.validateHosRecordForMoreThan24Hours(
          fields,
          true,
        )
      )
        return;
      if (fields.serviceType === "Meal") {
        if (!HosTemplateEntryValidators.validateMealDuration(fields, true)) {
          return;
        }
      }

      if (action === "update") {
        // update record
        updatedCurrentHosRecords[selectedHosEntryIndex] = { ...fields };
      } else if (action === "add") {
        // add record
        updatedCurrentHosRecords = [...updatedCurrentHosRecords, fields];
      }
    }

    this.setState({
      selectedHosEntryIndex: -1,
      addEditHosEntryData: {},
      addEditHosEntryFormState: null,
      openAddEditHosEntryForm: false,
    });
    this.props.updateHosRecords(updatedCurrentHosRecords);
  }

  render() {
    const { getServiceTypeBasedOnDutyType, getActivityTypeSelectOptionsBasedOnServiceType } = this.context;
    const { openAddEditHosEntryForm, addEditHosEntryData, addEditHosEntryFormSchema, addEditHosEntryFormState } = this.state;
    const { currentHosRecords, hideActions } = this.props;
    const { timezone } = this.props;

    return (
      <Fragment>
        {hideActions ? (
          <Fragment>
            <UISectionHeader
              title={languageService("Reporting Period")}
              addPermission={true && !this.props.disabled}
              addButtonTitle={languageService("Add HOS Entry")}
              addCallback={this.openCreateHosEntryForm}
            />
            <ThisTable
              tableColumns={[
                ...hosTemplateReportingPeriodTableSchema,
                {
                  Header: languageService("Actions"),
                  id: "actions",
                  Cell: (d) => {
                    const index = d.row._index;
                    const lastEntry = index + 1 === currentHosRecords.length;
                    if (this.props.disabled) return null;

                    return (
                      <div>
                        <StyledButtonActionsTable
                          title={languageService("Edit")}
                          onClick={() => this.openEditOrDeleteHosEntryForm(index, lastEntry ? "edit" : "partialEdit")}
                        />
                        {lastEntry ? (
                          <StyledButtonActionsTable
                            title={languageService("Delete")}
                            onClick={() => this.openEditOrDeleteHosEntryForm(index, "delete")}
                          />
                        ) : null}
                      </div>
                    );
                  },
                  minWidth: 150,
                },
              ]}
              tableData={currentHosRecords}
              pagination={false}
              forDashboard={false}
              height={"auto"}
              onClickSelect
            />
          </Fragment>
        ) : null}

        {openAddEditHosEntryForm && (
          <CustomForm
            mode="dialog"
            currState={addEditHosEntryFormState}
            fieldsData={addEditHosEntryData}
            formSchema={addEditHosEntryFormSchema}
            closeDialog={this.closeDialog}
            parentRef={{
              updateHosEntry: (submission) => this.addUpdateOrDeleteHosEntry(submission, "update"),
              addHosEntry: (submission) => this.addUpdateOrDeleteHosEntry(submission, "add"),
              confirmDeleteHosEntry: (submission) => this.addUpdateOrDeleteHosEntry(submission, "delete"),
              getServiceTypeOptionsBasedOnDutyType: (type) => {
                return arrayToSelectOptions(getServiceTypeBasedOnDutyType(type));
              },
              getActivityTypeOptionsBasedOnServiceType: (type) => {
                return getActivityTypeSelectOptionsBasedOnServiceType(type);
              },
            }}
          />
        )}

        {/* <MultiDayHosGraphicalView
          reportingPeriod={currentHosRecords.map((record) => ({
            ...record,
            startDate: getDateFromHosEntryTemplateDate(record.startDate, record.startTime, timezone),
            endDate: getDateFromHosEntryTemplateDate(record.endDate, record.endTime, timezone),
          }))}
          timezone={timezone}
          viewStartDate={getDateFromHosEntryTemplateDate(MIN_DATE, "00:00", timezone)}
          addMode={true}
          templateNameConvention={true} */}
        {/* /> */}
        <HosGraphicalView
          records={currentHosRecords.map((record) => ({
            ...record,
            startDate: getDateFromHosEntryTemplateDate(record.startDate, record.startTime, timezone),
            endDate: getDateFromHosEntryTemplateDate(record.endDate, record.endTime, timezone),
          }))}
          latestHosRecord={{}}
          timezone={timezone}
          viewStartDate={getDateFromHosEntryTemplateDate(MIN_DATE, "00:00", timezone)}
          templateNameConvention={true}
        />
      </Fragment>
    );
  }
}

AddHosEntries.defaultProps = {
  currentHosRecords: [],
  hq: "",
  pendingChanges: false,
  timezone: "",
  updateHosRecords: () => {},
  hideActions: true,
};

AddHosEntries.contextType = FixedAppLookupsContext;

export default AddHosEntries;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/EntryTemplates/AddHosEntries.jsx